import axios from 'axios';
import { notification } from 'antd';
import { api_url } from '../configs/app-global';
import { store } from '../redux/store';
import { clearUser } from '../redux/slices/auth';
import i18n from '../configs/i18next';
import { toast } from 'react-toastify';

const service = axios.create({
  baseURL: api_url,
  timeout: 16000,
});

// Config
const TOKEN_PAYLOAD_KEY = 'authorization';
const AUTH_TOKEN = 'token';
const AUTH_TOKEN_TYPE = 'Bearer';

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const access_token = localStorage.getItem(AUTH_TOKEN);

    if (access_token) {
      config.headers[TOKEN_PAYLOAD_KEY] = AUTH_TOKEN_TYPE + ' ' + access_token;
    }
    if (config.method === 'get') {
      config.params = { lang: i18n.language, ...config.params };
    }

    return config;
  },
  (error) => {
    // Do something with request error here
    notification.error({
      title: 'Error',
    });
    return Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error?.response?.status;

    let message =
      error?.response?.data?.message ||
      i18n.t('Something went wrong');

    // Unauthorized / Forbidden
    if (status === 401 || status === 403) {
      localStorage.removeItem(AUTH_TOKEN);
      store.dispatch(clearUser());
    }

    // Validation errors
    if (error?.response?.data?.params) {
      const firstError = Object.values(error.response.data.params)[0]?.[0];
      if (firstError) message = firstError;
    }

    toast.error(message, {
      toastId: status || 'network-error',
    });

    return Promise.reject(error);
  }
);


export default service;
